import { WAG_API_URL, WalkerProfileV6Endpoints } from '../../../constants';
import { V6HomePhotosParams, WalkerServiceCategoryGallery } from '../../../types/api';
import { tryCatch } from '../../../utils';
import { httpGet } from '../../../wag-react/common/api/api';
import { applyPathParams } from '../../../wag-react/common/api/utils/applyPathParams';

type Props = {
  identifier: string;
  category: string;
  queryParams?: V6HomePhotosParams;
}

export const getWalkerServiceCategoryGallery = async ({
  identifier,
  category,
  queryParams,
}: Props) => {
  const walkerServiceCategoryGalleryUrl = applyPathParams(
    WalkerProfileV6Endpoints.GetWalkerOfferedServicesGallery)({ identifier, category });

  const [{ data: serviceCategoryResponseData }, err] = await tryCatch(
    () => httpGet<WalkerServiceCategoryGallery>(walkerServiceCategoryGalleryUrl, {
      baseURL: WAG_API_URL,
      params: queryParams,
    }));

  if (err) {
    return null;
  }

  return serviceCategoryResponseData;
};
